<template>
  <div v-if="category" :class="$style.container">
    <div
      v-if="category.icon"
      :style="`background-image: url(${category.icon})`"
      :class="$style.icon"
    ></div>
    <div>{{ name }}</div>
  </div>
</template>

<script>
import { camelCase } from 'lodash'

export default {
  name: 'blog-post-category',
  props: {
    category: Object
  },
  computed: {
    name () {
      if (!this.category) return ''
      const locale = camelCase(this.$i18n.locale) // zhHans
      return this.category[locale] || this.category[this.$i18n.fallbackLocale]
    }
  }
}
</script>

<style module lang="scss">
.container {
  display: flex;
}
.icon {
  width: 16px;
  height: 16px;
  background-size: 1100%;
  background-position: center;
  margin-right: 6px;
}
</style>
